/* eslint-disable react/prop-types */
import React, { useState } from 'react';

/**
 * Truncates long text with "…" and a "more" control; click to show full text, "less" to collapse.
 */
const ExpandableText = ({ text, limit = 160, className = '', as: Component = 'div' }) => {
  const [expanded, setExpanded] = useState(false);

  if (text == null || text === '') return null;
  const trimmed = String(text).trim();
  if (!trimmed) return null;

  if (trimmed.length <= limit) {
    return <Component className={className}>{trimmed}</Component>;
  }

  const preview = trimmed.slice(0, limit).replace(/\s+$/, '') || trimmed.slice(0, limit);

  return (
    <Component className={className}>
      <span className="expandable-text-body">
        {expanded ? trimmed : `${preview}…`}
      </span>{' '}
      <button
        type="button"
        className="expandable-text-more-btn"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        {expanded ? 'less' : 'more'}
      </button>
    </Component>
  );
};

export default ExpandableText;
